module.exports = __webpack_public_path__ + "static/media/small_literary_art.43fca219.jpg";